// @flow
import { useInfiniteQuery } from 'react-query';

import useClientId from 'common/hooks/useClientId';
// eslint-disable-next-line max-len
import { WaybillUnsedSearchResponse } from 'platform/settings/modules/orchestration/models/internal/WaybillUnsedSearchResponse';
import { pregenWaybillUnusedSearch as pregenWaybillUnusedSearchApi } from 'platform/settings/modules/orchestration/api';

type Options = {
    carrierId: string,
    serviceType: string,
    searchKey?: string,
    pageSize?: number
};

const useGetWaybillUnusedSearch = (options: Options): $FixMe => {
    const { carrierId, serviceType, searchKey = '', pageSize = 100 } = options;

    const clientId = useClientId();

    return useInfiniteQuery({
        queryKey: ['client', clientId, 'waybill-unused-search', options],
        // In the initial load the pageParam will be null.
        queryFn: async ({ pageParam = 1 }) => {
            const data = await pregenWaybillUnusedSearchApi.post(
                { clientId },
                {
                    carrierId,
                    serviceType,
                    searchKey,
                    page: pageParam,
                    size: pageSize
                }
            );

            return WaybillUnsedSearchResponse.fromJS(data);
        },
        getNextPageParam: ({
            paginationInfo: { numberOfPages, currentPage }
        }: WaybillUnsedSearchResponse) => {
            return currentPage < numberOfPages ? currentPage + 1 : null;
        },

        refetchOnWindowFocus: false
    });
};

export default useGetWaybillUnusedSearch;
